import React from 'react';
import { formatTestId } from '../../../../utils/test-id/format-testid';
import { Image } from '../../Image/Image';
import { Icon } from '../Icon/Icon';
import styles from './NavLink.scss';
import classNames from 'classnames';

type NavLinkProps = {
  asAnchor?: boolean;
  isExtra?: boolean;
  label: string;
  url?: string;
  handleClick: () => void;
  shouldShowIcon?: boolean;
  tab?: string;
  imageUrl: string;
  hierarchy: string[];
  testId?: string;
  tabIndex?: number;
};

export const NavLink = ({
  asAnchor = false,
  isExtra = false,
  label,
  url,
  handleClick,
  shouldShowIcon,
  tab,
  imageUrl,
  hierarchy,
  testId,
  tabIndex,
}: NavLinkProps) => {
  const getTestId =
    testId || formatTestId(label, tab === 'Money' ? 'services-' : 'nav-');
  const Wrapper = asAnchor ? 'a' : 'button';

  const isExternal = asAnchor && url && !url.startsWith('/');

  const anchorProps = {
    href: url,
    target: isExternal ? '_blank' : undefined,
    rel: isExternal ? 'noreferrer' : undefined,
  };

  return (
    <Wrapper
      onClick={handleClick}
      {...(asAnchor ? anchorProps : {})}
      tabIndex={tabIndex}
      data-testid={getTestId}
      aria-label={
        label.endsWith('*')
          ? `${label.replace('*', '')} selected lines only`
          : label
      }
      data-hierarchy={hierarchy.join('|')}
      className={classNames(styles.button, {
        [styles.withThumbnail]: !!imageUrl,
        [styles.isExtra]: isExtra,
      })}
    >
      {!!imageUrl && (
        <Image url={imageUrl} label={label} width={64} height={64} />
      )}
      {shouldShowIcon && !imageUrl && <Icon label={label} />}
      {label}
    </Wrapper>
  );
};
